module.exports = __webpack_public_path__ + "assets/21918a4d5f62f3d189a4f60cfeb6b407.svg";